import { FC, JSX, useEffect, useState } from "react";
import "./SectionsArticles.scss";
import MasterPage from "../../../pages/MasterPage/MasterPage";
import PageBase from "../../../components/PageBase/PageBase";
import SkeletonTable from "../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../providers/PaginateProvider";
import SidebarSectionsArticlesFilter from "../../../components/Articles/Sections/SidebarSectionsArticlesFilter/SidebarSectionsArticlesFilter";
import ModalSectionsArticlesInsert from "../../../components/Articles/Sections/ModalSectionsArticlesInsert/ModalSectionsArticlesInsert";
import { useSections } from "../../../providers/Articles/Sections/SectionsProvider";
import { SectionsModel } from "../../../models/Articles/Sections/SectionsModel";
import { useSidebarFilter } from "../../../providers/SidebarFilterProvider";
import moment from "moment";
import { useAgentsCategories } from "../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import ModalSortSectionsInsert from "../../../components/ModalSortSectionsInsert/ModalSortSectionsInsert";

interface SectionsArticlesProps {}

const SectionsArticles: FC<SectionsArticlesProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [selectedSection, setSelectedSection] = useState<SectionsModel>();
  const [showModalSectionsInsert, setShowModalSectionsInsert] =
    useState<boolean>(false);

  const {
    handleListSections,
    handleDeleteSection,
    handleReactivate,
    error,
    sections,
    isLoading,
    pages,
    params,
    setParams,
    setIsLoading,
  } = useSections();
  const { setParams: setParamsAgentsCategories } = useAgentsCategories();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();

  useEffect(() => {
    handleListSections();
  }, []);

  const handleEdit = (item: SectionsModel) => {
    setSelectedSection(item);
    setShowModalInsert(true);
  };

  const handleCloseModal = () => {
    setShowModalInsert(false);
    setSelectedSection({});
  };

  const handleReactivateItem = async (itemId: number) => {
    if (itemId <= 0) return;

    const ret = await handleReactivate(itemId);

    if (ret) {
      toast.success("Seção reativada com sucesso!");
      handleListSections();
    }
  };

  const handleDeleteSectionsArticles = (item: any) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir a Seção ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDeleteSection(item.id || 0).then();
        if (ret) {
          toast.success("Seção inativada com sucesso!");
          handleListSections();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar a Seção.<br>${error}`,
            "error"
          );
        }
      }
    });
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {sections?.length > 0 ? (
          <>
            {sections.map((x: SectionsModel, key: number) => (
              <tr key={key} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td className="col-medium">{x?.name}</td>
                <td className="text-wrap description-cell">{x?.description}</td>
                <td>{x?.category?.name}</td>
                <td className="text-center">
                  <span
                    className={
                      x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                    }
                  >
                    {x?.deleted_at ? "Inativo" : "Ativo"}
                  </span>
                </td>
                <td className="text-center">
                  {moment(x?.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    {!x?.deleted_at && (
                      <>
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleEdit(x)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
                          Editar
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleDeleteSectionsArticles(x)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                          Remover
                        </Dropdown.Item>
                      </>
                    )}
                    {x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleReactivateItem(x?.id ?? 0)}
                      >
                        <FontAwesomeIcon
                          icon={faCircleCheck}
                          className="me-2"
                        />
                        Reativar
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={7} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7 w-25" scope="col">
                      Descrição
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Categoria
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de Cadastro
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {sections?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    !!showModalInsert &&
      setParamsAgentsCategories({
        withPaginate: false,
        filter: { only_active: true },
      });
  }, [showModalInsert]);

  useEffect(() => {
    setParams({ ...params, page: 1, filter: { only_active: false } });
  }, []);

  return (
    <MasterPage title="Seções de Artigos" icon="fas fa-file" footerFixed>
      <div className="SectionsArticles" data-testid="SectionsArticles">
        <PageBase
          title="Seções de Artigos"
          subtitle="Gerenciamento de Seções de Artigos."
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          renderBtnAux2={
            <div>
              <button
                type="button"
                className="btn btn-outline-primary text-primary btn-sm mb-0"
                onClick={() => setShowModalSectionsInsert(true)}
              >
                +&nbsp; Ordernar Seções
              </button>
            </div>
          }
          hasFilter
        />

        <ModalSectionsArticlesInsert
          show={showModalInsert}
          selectedSection={selectedSection}
          onClose={() => handleCloseModal()}
        />

        <ModalSortSectionsInsert
          show={showModalSectionsInsert}
          onClose={() => setShowModalSectionsInsert(false)}
        />
      </div>

      <SidebarSectionsArticlesFilter />
    </MasterPage>
  );
};

export default SectionsArticles;
